import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

export type Notification = {
  type: "SUCCESS" | "ERROR" | "ABORTED";
  message: string;
};

@Injectable({
  providedIn: "root",
})
export class NotificationService {
  private notificationSubject = new Subject<Notification | undefined>();
  private clearDelay: number = 3000;

  constructor() {}

  setClearDelay(delay: number) {
    this.clearDelay = delay;
  }

  push(notification: Notification) {
    this.notificationSubject.next(notification);
    setTimeout(() => {
      this.clear();
    }, this.clearDelay);
  }

  clear() {
    this.notificationSubject.next(undefined);
  }

  get() {
    return this.notificationSubject;
  }
}
